import type { FooterSection } from 'src/components/global/types/footer-section'
import { sendEvent, makeEventTrack } from 'src/utils/restructure/analytics'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { object, string } from 'zod'

export type FooterCTACategory =
  | 'Baixe o app'
  | 'Seja membro'
  | 'Redes sociais'
  | 'Serviços'
  | 'Ajuda'
  | 'Sobre'
  | 'Políticas'

export type TrackFooterCTAParams = {
  ctaCategory: FooterCTACategory
  ctaName: string
}

export function validateFooter() {
  function validateProps(props?: FooterSection) {
    try {
      const schema = object({
        title: string().optional(),
        serviceLinks: object({
          text: string(),
          link: string(),
        }).array(),
        helpLinks: object({
          text: string(),
          link: string(),
        }).array(),
        aboutUsLinks: object({
          text: string(),
          link: string(),
        }).array(),
        deliveryPolicy: object({
          text: string(),
          link: string(),
        }),
        privacyPolicy: object({
          text: string(),
          link: string(),
        }),
        copyRight: string(),
      })

      schema.parse(props)

      return true
    } catch (e) {
      return false
    }
  }

  const sendEventRedirect = ({
    ctaCategory,
    ctaName,
    standardEventProperties,
  }: TrackFooterCTAParams & {
    standardEventProperties: Record<string, unknown> | null
  }) => {
    const eventPageFromStandardObject =
      standardEventProperties?.['page name'] ??
      standardEventProperties?.['page type']

    const finalEvent = makeEventTrack({
      eventAction: `${ctaName} - footer`,
      eventPage:
        typeof eventPageFromStandardObject === 'string' &&
        eventPageFromStandardObject.trim() !== ''
          ? eventPageFromStandardObject
          : 'Home',
    })

    sendEvent(finalEvent)

    dispatchAmplitudeEvent({
      eventName: 'CTA Footer',
      eventData: {
        ...(standardEventProperties ?? {}),
        'cta category': ctaCategory,
        'cta name': ctaName,
      },
    })
  }

  return {
    validateProps,
    sendEventRedirect,
  }
}
